<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="card bg-light">
    <div *ngIf="valuesCount > 7" class="card-body">
        <!--<table class="table table-responsive" style="border-radius: 5px; font-size: 12px; width: 95%;"></table>-->
        <table class="table table-borderless">
            <tr style="font-size: medium">
                <th style="width: 10%;">&nbsp;</th>
                <th style="width: 50%;">&nbsp;</th>
                <th style="width: 5%;">&nbsp;</th>
                <th style="width: 10%;">&nbsp;</th>
                <th style="width: 25%;">Roll Value per Assessor</th>
            </tr>
            <tr>
                <td class="prd-label" style="font-size: small;">Division </td>
                <div *ngIf="showForAccessLevel(1)">
                    <td><input type="text" disabled class="form-control input-sm" [(ngModel)]="myAssessor.division"></td>
                </div>
                <div *ngIf="showForAccessLevel(3)">
                    <td>
                        <select class="form-control" id="selectDivision" [(ngModel)]="myAssessor.division" tabindex="501">
                            <option *ngFor="let anOpt of assessorDivisionChoiceList" >{{anOpt.division}}</option>
                        </select>
                    </td>

                </div>
                <td>&nbsp;</td>
                <td class="prd-label" style="font-size: small;"> Land </td>
                <div *ngIf="showForAccessLevel(1)">
                    <td><input type="text" disabled class="form-control input-sm" [(ngModel)]="myValueAssessor.landValue"></td>
                </div>
                <div *ngIf="showForAccessLevel(3)">
                    <td>
                        <input type="text" class="form-control input-sm" [(ngModel)]="myValueAssessor.landValue"
                        (blur)="addCommas(3)" (focus)="removeCommas(3)" tabindex="510">
                    </td>
                </div>
            </tr>
            <tr>
                <td class="prd-label" style="font-size: small;">Crew </td>
                <div *ngIf="showForAccessLevel(1)">
                    <td><input type="text" disabled class="form-control input-sm" [(ngModel)]="myAssessor.crew"></td>
                </div>
                <div *ngIf="showForAccessLevel(3)">
                    <td>
                        <select class="form-control" id="selectCrew" [(ngModel)]="myAssessor.crew" tabindex="502">
                            <option *ngFor="let anOpt of assessorCrewChoiceList">{{anOpt.crew}}</option>
                        </select>
                    </td>
                </div>
                <td>&nbsp;</td>
                <td class="prd-label" style="font-size: small;">Improvements </td>
                <div *ngIf="showForAccessLevel(1)">
                    <td><input type="text" disabled class="form-control input-sm" [(ngModel)]="myValueAssessor.improveValue"></td>
                </div>
                <div *ngIf="showForAccessLevel(3)">
                    <td>
                        <input type="text" class="form-control input-sm" [(ngModel)]="myValueAssessor.improveValue"
                        (blur)="addCommas(13)" (focus)="removeCommas(13)" tabindex="511">
                    </td>
                </div>
            </tr>
            <tr>
                <td class="prd-label" style="font-size: small;">Appraiser </td>
                <div *ngIf="showForAccessLevel(1)">
                    <td><input type="text" disabled class="form-control input-sm" [(ngModel)]="myAssessor.appraiserName"></td>
                </div>
                <div *ngIf="showForAccessLevel(3)">
                    <td>
                        <select class="form-control" id="selectAppraiser" [(ngModel)]="myAssessor.appraiserId" tabindex="503" (change)="changeAssessor()">
                            <option *ngFor="let anOpt of appraiserChoiceList" value="{{anOpt.id}}">{{anOpt.name}}</option>
                        </select>
                    </td>
                </div>
                <td>&nbsp;</td>
                <td class="prd-label" style="font-size: small;">Fixtures </td>
                <div *ngIf="showForAccessLevel(1)">
                    <td><input type="text" disabled class="form-control input-sm" [(ngModel)]="myValueAssessor.fixturesValue"></td>
                </div>
                <div *ngIf="showForAccessLevel(3)">
                    <td>
                        <input type="text" class="form-control input-sm" [(ngModel)]="myValueAssessor.fixturesValue"
                        (blur)="addCommas(23)" (focus)="removeCommas(23)" tabindex="512">
                    </td>
                </div>
            </tr>

            <tr>
                <td class="prd-label" style="font-size: small;">Special Case Identifier </td>
                <div *ngIf="showForAccessLevel(1)">
                    <td><input type="text" disabled class="form-control input-sm" [(ngModel)]="myAssessor.specialCase"></td>
                </div>
                <div *ngIf="showForAccessLevel(3)">
                    <td>
                        <select class="form-control" id="selectCrew2" [(ngModel)]="myAssessor.specialCase" tabindex="504">
                                <option *ngFor="let anOpt of assessorSpecialCaseChoiceList">{{anOpt.specialCase}}</option>
                            </select>
                    </td>
                </div>
                <td>&nbsp;</td>
                <td class="prd-label" style="font-size: small;">Personal Property </td>
                <div *ngIf="showForAccessLevel(1)">
                    <td><input type="text" disabled class="form-control input-sm" [(ngModel)]="myValueAssessor.personalValue"></td>
                </div>
                <div *ngIf="showForAccessLevel(3)">
                    <td>
                        <input type="text" class="form-control input-sm" [(ngModel)]="myValueAssessor.personalValue"
                        (blur)="addCommas(33)" (focus)="removeCommas(33)" tabindex="513">
                    </td>
                </div>
            </tr>
            <tr>
                <td class="prd-label" style="font-size: small;">Property/Use Code </td>
                <div *ngIf="showForAccessLevel(1)">
                    <td><input type="text" disabled class="form-control input-sm" [(ngModel)]="myProperty.useCode"></td>
                </div>
                <div *ngIf="showForAccessLevel(3)">
                    <td>
                        <select class="form-control" id="selectUseCode" [(ngModel)]="myProperty.useCode" tabindex="505">
                                <option *ngFor="let anOpt of useCodeChoiceList" value="{{anOpt.description}}">{{anOpt.description}}</option>
                            </select>
                    </td>
                </div>
                <td>&nbsp;</td>
                <td class="prd-label" style="font-size: small;">Mineral Rights </td>
                <div *ngIf="showForAccessLevel(1)">
                    <td><input type="text" disabled class="form-control input-sm" [(ngModel)]="myValueAssessor.mineralValue"></td>
                </div>
                <div *ngIf="showForAccessLevel(3)">
                    <td>
                        <input type="text" class="form-control input-sm" [(ngModel)]="myValueAssessor.mineralValue"
                        (blur)="addCommas(43)" (focus)="removeCommas(43)" tabindex="514">
                    </td>
                </div>
            </tr>
            <tr>
                <td class="prd-label" style="font-size: small;">Complex Case</td>

                <div *ngIf="showForAccessLevel(0)">
                    <td>
                        <input type="checkbox" disabled class="form-control" [(ngModel)]="myAssessor.complexCase" style="width: 100px;">
                    </td>
                </div>
                <div *ngIf="!showForAccessLevel(0)">
                    <td>
                        <input type="checkbox" [(ngModel)]="myAssessor.complexCase" tabindex="506">
                    </td>
                </div>
                <td>&nbsp;</td>
                <td class="prd-label" style="font-size: small;">Trees and Vines</td>
                <div *ngIf="showForAccessLevel(1)">
                    <td><input type="text" disabled class="form-control input-sm" [(ngModel)]="myValueAssessor.treesValue"></td>
                </div>
                <div *ngIf="showForAccessLevel(3)">
                    <td>
                        <input type="text" class="form-control input-sm" [(ngModel)]="myValueAssessor.treesValue"
                        (blur)="addCommas(53)" (focus)="removeCommas(53)" tabindex="515">
                    </td>
                </div>
            </tr>

            <tr>
                <td class="prd-label" style="font-size: small;">Comment</td>
                <div *ngIf="showForAccessLevel(0)">
                    <td><textarea rows="8" cols="100" disabled class="form-control input-sm col-sm-12" [(ngModel)]="myAssessor.comments"></textarea></td>
                </div>
                <div *ngIf="!showForAccessLevel(0)">
                    <td><textarea rows="8" cols="100" class="form-control col-sm-12" [(ngModel)]="myAssessor.comments" tabindex="506"></textarea></td>
                </div>

                <td>&nbsp;</td>
                <td><b>Total Value</b> </td>
                <td> <span class="h4">{{myTotalValue}}</span> </td>
            </tr>

            <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td class="prd-label" style="font-size: small;">Exemptions</td>
                <div *ngIf="showForAccessLevel(1)">
                    <td><input type="text" disabled class="form-control input-sm" [(ngModel)]="myValueAssessor.exemptValue"></td>
                </div>
                <div *ngIf="!showForAccessLevel(1)">
                    <td>
                        <input type="text" class="form-control input-sm" [(ngModel)]="myValueAssessor.exemptValue"
                        (blur)="addCommas(63)" (focus)="removeCommas(63)" tabindex="516">
                    </td>
                </div>
            </tr>
            <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td class="prd-label" style="font-size: small;">Penalties</td>
                <div *ngIf="showForAccessLevel(1)">
                    <td><input type="text" disabled class="form-control input-sm" [(ngModel)]="myValueAssessor.penaltyValue"></td>
                </div>
                <div *ngIf="!showForAccessLevel(1)">
                    <td>
                        <input type="text" class="form-control input-sm" [(ngModel)]="myValueAssessor.penaltyValue"
                        (blur)="addCommas(73)" (focus)="removeCommas(73)" tabindex="517">
                    </td>
                </div>
            </tr>
            <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td class="prd-label" style="font-size: small;">Net Total</td>
                <div *ngIf="showForAccessLevel(1)">
                    <td><input type="text" disabled class="form-control input-sm" [(ngModel)]="myValueAssessor.netValue"></td>
                </div>
                <div *ngIf="showForAccessLevel(3)">
                    <td>
                        <input type="text" class="form-control input-sm" [(ngModel)]="myValueAssessor.netValue"
                        (blur)="addCommas(83)" (focus)="removeCommas(83)" tabindex="518">
                    </td>
                </div>
            </tr>
        </table>
        <hr />
        <div class="form-row">
            <div *ngIf="showForAccessLevel(3)" class="col-md-2 offset-5">
                <button class="btn btn-success" (click)="saveAssessor()">Save Assessor Info</button>
            </div>
            <div *ngIf="showForAccessLevel(2)" class="col-md-3">
                <button class="btn btn-success" (click)="saveComment()">Save Comment</button>
            </div>
        </div>
    </div>
</div>
<p-messages key="infoAssessor"></p-messages>
<p-toast key="toastAssessor" [style]="{marginTop: '80px'}"></p-toast>
